import React from 'react';
import PropTypes from 'prop-types';

/**
 * The tab strip the prototype puts on detail pages.
 *
 * Controlled, and the caller decides where the active tab lives. On the purchase
 * detail that is component state; a page whose tab should survive a reload or be
 * shareable can put it in the URL instead without this component changing.
 *
 * `count` renders a number beside the label — useful when a tab holds a list, so
 * "Participants 0" says there are none rather than making you click to find out.
 */
export default function Tabs({ tabs, active, onChange }) {
  return (
    <div className="next-tabs" role="tablist">
      {tabs.map(({ key, label, count }) => (
        <button
          type="button"
          key={key}
          role="tab"
          aria-selected={active === key}
          className={`next-tabs__tab${active === key ? ' next-tabs__tab--active' : ''}`}
          onClick={() => onChange(key)}
        >
          {label}
          {count !== undefined && count !== null && (
            <span className="next-count">{count}</span>
          )}
        </button>
      ))}
    </div>
  );
}

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    count: PropTypes.number
  })).isRequired,
  active: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
};
